<template lang="pug">
  form(v-if="formData" @submit="submit($event, 'vistaSatelital')" enctype="multipart/form-data")
    .vista-satelital-container
      .v-subtitle Imágenes para vista satelital

      .vista-satelital-container
        .v-subtitle Área y tooltip del proyecto

        image-field(
          clearable
          label="Área del proyecto"
          v-model="formData.shapes"
          :src="getImageSRC('shapes', '01.svg')"
          :error-messages="getMessageErrors('formData.shapes')"
          :disabled="sending"
          accept="image/svg+xml"
          @change-files="loadSVG($event, 'shapes')"
          @input="$v.formData.shapes.$touch()"
          @blur="$v.formData.shapes.$touch()"
        )

        image-field(
          clearable
          label="Tooltip del proyecto"
          v-model="formData.tooltip"
          :src="getImageSRC('tooltip', 'tooltip.svg')"
          :error-messages="getMessageErrors('formData.tooltip')"
          :disabled="sending"
          accept="image/svg+xml"
          @change-files="loadSVG($event, 'tooltip')"
          @input="$v.formData.tooltip.$touch()"
          @blur="$v.formData.tooltip.$touch()"
        )

      .vista-satelital-container(v-if="formData.markerPositions")
        .v-subtitle Pin del proyecto y sus posiciones en la vista

        image-field(
          clearable
          label="Pin"
          v-model="formData.pin"
          :src="getImageSRC('pin', 'pin.svg')"
          :error-messages="getMessageErrors('formData.pin')"
          :disabled="sending"
          accept="image/svg+xml"
          @change-files="loadSVG($event, 'pin')"
          @input="$v.formData.pin.$touch()"
          @blur="$v.formData.pin.$touch()"
        )

        v-text-field(
          clearable
          color="primary"
          label="Top (px)"
          v-model="calculated.top"
          :disabled="sending"
          hint="Debe cargar un número correspondiente a la posición superior en pixeles del pin (Valor utilizado para calcular el valor en porcentaje)"
          persistent-hint
        )

        v-text-field(
          clearable
          color="primary"
          label="Left (px)"
          v-model="calculated.left"
          :disabled="sending"
          hint="Debe cargar un número correspondiente a la posición de izquierda en pixeles del pin (Valor utilizado para calcular el valor en porcentaje)"
          persistent-hint
        )

        v-text-field(
          clearable
          color="primary"
          label="Top (%)"
          v-model="formData.markerPositions.top"
          :disabled="sending"
          :error-messages="getMessageErrors('formData.markerPositions.top')"
          hint="Debe cargar el valor con la unidad de medida y necesariamente debe estar en porcentaje, ejemplo: 70.75%"
          persistent-hint
          @input="$v.formData.markerPositions.top.$touch()"
          @blur="$v.formData.markerPositions.top.$touch()"
        )

        v-text-field(
          clearable
          color="primary"
          label="Left (%)"
          v-model="formData.markerPositions.left"
          :disabled="sending"
          :error-messages="getMessageErrors('formData.markerPositions.left')"
          hint="Debe cargar el valor con la unidad de medida y necesariamente debe estar en porcentaje, ejemplo: 70.75%"
          persistent-hint
          @input="$v.formData.markerPositions.left.$touch()"
          @blur="$v.formData.markerPositions.left.$touch()"
        )

      .vista-satelital-container
        .v-subtitle Imagenes para estado del proyecto

        .vista-satelital-estados.first-child
          image-field(
            clearable
            label="Estado de Planificación"
            v-model="formData.planificacion"
            :src="getImageSRC('planificacion', 'planificacion.svg')"
            :error-messages="getMessageErrors('formData.planificacion')"
            :disabled="sending"
            accept="image/svg+xml"
            @change-files="loadSVG($event, 'planificacion')"
            @input="$v.formData.planificacion.$touch()"
            @blur="$v.formData.planificacion.$touch()"
          )

        .vista-satelital-estados
          image-field(
            clearable
            label="Estado de Ejecución"
            v-model="formData.ejecucion"
            :src="getImageSRC('ejecucion', 'ejecucion.svg')"
            :error-messages="getMessageErrors('formData.ejecucion')"
            :disabled="sending"
            accept="image/svg+xml"
            @change-files="loadSVG($event, 'ejecucion')"
            @input="$v.formData.ejecucion.$touch()"
            @blur="$v.formData.ejecucion.$touch()"
          )

        .vista-satelital-estados
          image-field(
            clearable
            label="Estado de Cierre"
            v-model="formData.cierre"
            :src="getImageSRC('cierre', 'cierre.svg')"
            :error-messages="getMessageErrors('formData.cierre')"
            :disabled="sending"
            accept="image/svg+xml"
            @change-files="loadSVG($event, 'cierre')"
            @input="$v.formData.cierre.$touch()"
            @blur="$v.formData.cierre.$touch()"
          )

    v-btn(color="primary" v-show="!isCreateView" type="submit" ref="saveButton") Guardar

</template>

<script>
import projectFormMixin from '@/mixins/project-form.js'

export default {
  mixins: [ projectFormMixin ],
  components: {
    ImageField: () => import('@/components/utils/ImageField')
  },
  data: () => ({
    files: null,
    calculated: {
      top: 0,
      left: 0
    }
  }),
  created () {
    this.initFilesValues()
  },
  validations () {
    return {
      formData: {
        markerPositions: {
          top: { },
          left: { }
        },
        shapes: { },
        pin: { },
        cierre: { },
        planificacion: { },
        ejecucion: { },
        tooltip: { },
        ...this.customValidations
      }
    }
  },
  methods: {
    initFilesValues () {
      if (!this.files) this.files = {}
      if (!this.files.shapes) this.files.shapes = []
      if (!this.files.pin) this.files.pin = []
      if (!this.files.cierre) this.files.cierre = []
      if (!this.files.planificacion) this.files.planificacion = []
      if (!this.files.ejecucion) this.files.ejecucion = []
      if (!this.files.tooltip) this.files.tooltip = []
    },
    loadSVG (event, fieldName) {
      if (event && event.length) {
        const file = event[0]
        this.files[fieldName][0] = file
        this.$set(this.formData, fieldName, file.name)
        this.$emit('input', this.formData)
        this.$emit('on-change-files', this.files)
      }
    }
  },
  computed: {
    messageErrorsByCode () {
      if (!this.$v.formData.code.$dirty) return []
      const errors = this.getMessageErrors('formData.code')
      !this.$v.formData.code.codeValidator && errors.push('El valor introducido es incorrecto, solo se permiten números, letras en minúsculas o guiones')
      return errors
    }
  },
  watch: {
    'calculated.top' (val) {
      this.formData.markerPositions.top = ((parseFloat(val) * 100) / 1080) + '%'
    },
    'calculated.left' (val) {
      this.formData.markerPositions.left = ((parseFloat(val) * 100) / 1920) + '%'
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~@/styles/edit-project-form-style'

.vista-satelital-container
  border-radius: 3px
  border: 1px solid $gray
  padding: $f20px
  button
    margin-top: 0
    margin-left: 0

.vista-satelital-container
  margin-bottom: $f30px

.vista-satelital-estados
  background-color: #346c87
  border-radius: 3px
  padding-right: $f20px

.v-subtitle
  margin: 0 0 $f20px

</style>
